<template>
  <div class="card-body">

    <h4 class="card-title mb-3">Live Webinar</h4>
      <form @submit.prevent="submitForm">
        <div class="col-12 mb-4">
          <label><b>Title</b></label>
          <input class="form-control" type="text" v-model="data.title" />
        </div>
  
        <div class="col-12 mb-4">
          <label><b>Description</b></label>
          <ckeditor
            :editor="editor"
            v-model="data.description"
            :config="editorConfig"
          ></ckeditor>
        </div>
  
        <div class="col-12 mb-4">
          <label><b>Link</b></label>
          <input class="form-control" type="text" v-model="data.link" />
        </div>

        <div class="row px-3">
          <div class="col-6 mb-4">
            <label><b>Date</b></label>
            <input class="form-control" type="date" v-model="data.date" />
          </div>
  
          <div class="col-6 mb-4">
            <label><b>Time</b></label>
            <input class="form-control" type="time" v-model="data.time" />
          </div>

        </div>

        <div class="col-12 mb-4">
          <label><b>Status</b></label>
          <div class="row">
            <label class="radio radio-success ml-3">
                <input type="radio" name="activeStatus" v-model="data.status" v-bind:value="a">
                <span>Active</span>
                <span class="checkmark"></span>
            </label>
            <label class="radio radio-danger ml-3">
                <input type="radio" name="activeStatus" v-model="data.status"  v-bind:value="b">
                <span>Inactive</span>
                <span class="checkmark"></span>
            </label>
          </div>
        </div>
  
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-primary btn-wide mt-4 btn-rounded"
          >
            Submit 
          </button>
        </div>
      </form>

    </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getWebinar, updateWebinar } from "@/services/WebinarService";

export default {

  components: { ckeditor: CKEditor.component },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      a: 1,
      b: 0,

      data: {
        description: '',
        title: '',
        link: '',
        status: '',
        date: '',
        time: ''
      }
    }
  },

  methods: {
    async fetchWebinar() {
      try {
        const response = await getWebinar();

        if(response.data.success) {
          this.data = response.data.data == null ? {
            description: '',
            title: '',
            link: '',
            status: '',
            date: '',
            time: ''
          }
          :
          response.data.data;
          
          this.data.status = this.data.status == "Active" ? 1 : 0;
        } else {
          throw new Error(response);
        }

      } catch (e) {
        console.log(e)
      }
    },

    async submitForm() {
      try {
        const response = await updateWebinar(this.data);

        swal({
          title: response.data.success ? 'Success' : 'Failed',
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });
      } catch (e) {
        console.error(e);
      }
    },
  },

  async mounted() {
    await this.fetchWebinar();
  },
}

</script>
